export enum VendorLevel {
  CAMPAIGN = 'CAMPAIGN',
  SUB_CAMPAIGN = 'SUB_CAMPAIGN'
}

export enum VendorConfiguredAt {
  ID = 'ID',
  NAME = 'NAME'
}
